import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import Blank from './Blank';

const FillInTheBlankQuestion = props => {
  const { id, required } = props;
  return (
    <QuestionWrapper {...props}>
      <p className="lh-29">
        {read(props.prompt).map(
          (seg, i) =>
            typeof seg === 'string' ? (
              <span key={i} dangerouslySetInnerHTML={{ __html: seg }} />
            ) : (
              <Blank
                className="ta-c v-base"
                style={{
                  borderWidth: '0 0 1px',
                  boxShadow: 'none',
                  borderColor: '#666',
                }}
                key={i}
                index={seg}
                name={`questions[${props.name}][]`}
                questionId={id}
                required={required}
                type="text"
              />
            )
        )}
      </p>
    </QuestionWrapper>
  );
};

FillInTheBlankQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string,
};

export default FillInTheBlankQuestion;

// Utils

/* Ex. read('Hi, my name is ___. I like to ___.')
  returns [ 'Hi, my name is ', 0, '. I like to ', 1, '.' ]
*/
const pattern = new RegExp(/__{2,}/g);
export const read = prompt => {
  return (prompt + '').split(pattern).reduce((acc, seg, idx, segments) => {
    return segments.length === idx + 1
      ? acc.concat([seg])
      : acc.concat([seg, idx]);
  }, []);
};
